module.exports = __webpack_public_path__ + "img/1.3d1defe8.jpg";